import { render, staticRenderFns } from "./StoryTitle.vue?vue&type=template&id=73d58256"
import script from "./StoryTitle.vue?vue&type=script&lang=js"
export * from "./StoryTitle.vue?vue&type=script&lang=js"
import style0 from "./StoryTitle.vue?vue&type=style&index=0&id=73d58256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports